import { createSelector } from 'reselect';
import { compareCards } from './utils';
import { countrySelector } from '../../selectors';
import { EUR_COUNTRIES, EURO_CURRENCY_RATES } from '../../payments';

export const cardsSelector = ({ cards }) => cards;

export const cardsItemsSelector = createSelector(
  cardsSelector,
  ({ items }) => items,
);

export const cardsSortOrderSelector = createSelector(
  cardsSelector,
  ({ sortOrder }) => sortOrder,
);

export const premiumCardExchangeInfoSeenSelector = ({
  cards: { premiumCardExchangeInfoSeen },
}) => premiumCardExchangeInfoSeen;
export const cardsSelectedSelector = createSelector(
  cardsSelector,
  ({ cardsSelected, items }) =>
    cardsSelected.map((_id) => items[_id]).filter(Boolean),
);

export const sortedCardsSelector = createSelector(
  cardsItemsSelector,
  cardsSortOrderSelector,
  (items, sortOrder) => {
    const forSorting = [];
    const unsorted = [];
    Object.keys(items).forEach((cardId) => {
      const card = items[cardId];
      if (
        card &&
        card.cardTemplate &&
        !card.cardTemplate.hideInInventory &&
        !card.cardCollection &&
        !card.shredded
      ) {
        if (card.newest) {
          forSorting.push(card);
        } else {
          unsorted.push(card);
        }
      }
    });

    return {
      sorted: forSorting.sort((item1, item2) =>
        compareCards(item1, item2, sortOrder),
      ),
      unsorted,
    };
  },
);

export const inventoryValueSelector = createSelector(
  countrySelector,
  cardsSelector,
  (country, { totalRecords, value, lastSuccessfulFetch }) => {
    const loading = !lastSuccessfulFetch;

    if (loading) {
      return {
        value: 0,
        totalRecords: 0,
        currency: '',
        loading,
      };
    }

    const inEuro = Boolean(country && EUR_COUNTRIES.includes(country));
    const cardsValue = inEuro
      ? value.toFixed(0)
      : (value * EURO_CURRENCY_RATES.USD).toFixed(0);

    return {
      currency: inEuro ? '€' : '$',
      value: cardsValue,
      totalRecords,
      loading,
    };
  },
);

export const hasShrededCardsSelector = createSelector(
  cardsItemsSelector,
  (cardsMap) => {
    const cards = Object.values(cardsMap);
    return cards.length > 0 && !cards.some(({ shredded }) => shredded);
  },
);
